import { get } from "./fetch";

export const getListaProgramas = async (idioma:string = "es") => {
  //Stored Procedure: DashboardSituacion_Get_Programas
  var result = await get(`/api/programas?idioma=${idioma}`);
  return result;
};
